import scrollElementIntoView from './scrollElementIntoView';

const ATTEMPTS = 8;
const INTERVAL = 250;
const OFFSET = -70;

export const scrollToAnchorPost = (postId: string) => {
  if (!postId) return;

  const tryScroll = (attemptsLeft: number) => {
    const element = document.querySelector(`[data-rbd-draggable-id="${postId}"]`);
    if (element) {
      scrollElementIntoView(element, OFFSET);
      return;
    }
    if (attemptsLeft > 1) setTimeout(() => tryScroll(attemptsLeft - 1), INTERVAL);
  };

  tryScroll(ATTEMPTS);
};
import scrollElementIntoView from './scrollElementIntoView';

const ATTEMPTS = 8;
const INTERVAL = 250;
const OFFSET = -70;

export const scrollToAnchorPost = (postId: string) => {
  if (!postId) return;

  const tryScroll = (attemptsLeft: number) => {
    const element = document.querySelector(`[data-rbd-draggable-id="${postId}"]`);
    if (element) {
      scrollElementIntoView(element, OFFSET);
      return;
    }
    if (attemptsLeft > 1) setTimeout(() => tryScroll(attemptsLeft - 1), INTERVAL);
  };

  tryScroll(ATTEMPTS);
};
